<div class="usa-modal__content">
    <div class="usa-modal__main define-modal-style">
        <h2 class="usa-modal__heading" id="modal-2-heading">
            FRT Edit Rates - Modify/Delete Accessorials
        </h2>
        <div class="usa-prose">
            <form id="frtRateAccessorialsFormGroup" role="form" [formGroup]="frtRateAccessorialsFormGroup">
                <div class="grid-row" *ngIf="this.frtRateAccessorialsFormGroup.controls['accessorials'].value.length > 0">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                        <div class="usa-table-container--scrollable" tabindex="0">
                            <thead>
                                <th scope="col"> Delete</th>
                                <th scope="col"> Accessorial Description</th>
                                <th scope="col"> Rate Amount</th>
                                <th scope="col"> Rate Amount Limit</th>
                                <th scope="col"> Minimum Charge</th>
                                <th scope="col"> Min Charge Limit</th>
                            </thead>
                            <tbody formArrayName="accessorials" *ngFor="let control of this.frtRateAccessorialsFormGroup.get('accessorials')['controls'];
                                  let i = index">
                                <tr mdbTableCol [formGroupName]="i">
                                    <td class="text-center">
                                        <input type="checkbox" (change)="onSelectDelete($event.target.checked,control.get('accProcureId').value)">
                                    </td>
                                    <td>
                                        <input class="usa-input" type="text" formControlName="AccessorialCode" readonly>
                                    </td>
                                    <td>
                                        <input type="text" class="usa-input" maxlength="10" formControlName="RateAmount" (change)="onSelectRateAmount($event.target.value,control.get('accProcureId').value)">
                                        <span class="define-text-secondary" *ngIf="control.get('RateAmount').touched && control.get('RateAmount').hasError('pattern')">
                      <br>Rate Amount should have numbers only!</span>
                                        <span class="define-text-secondary" *ngIf="control.get('RateAmount').touched && control.get('RateAmount').hasError('rateAmt1')">
                      <br>Rate amount should not exceed the allowed maximum charge!</span>
                                    </td>
                                    <td>
                                        <input type="text" class="usa-input" formControlName="RateAmtLimit" readonly>
                                    </td>
                                    <td>
                                        <input type="text" class="usa-input" maxlength="10" formControlName="MinimumCharge" (change)="onSelectMinimumCharge($event.target.value,control.get('accProcureId').value)">
                                        <span class="define-text-secondary" *ngIf="control.get('MinimumCharge').touched && control.get('MinimumCharge').hasError('pattern')">
                      <br>Minimum Charge should have numbers only!</span>
                                        <span class="define-text-secondary" *ngIf="control.get('MinimumCharge').touched && control.get('MinimumCharge').hasError('minAmt1')">
                      <br>Minimum Charge should be grater than minimum allowed !</span>
                                    </td>
                                    <td>
                                        <input type="text" class="usa-input" formControlName="MinChgLimit" readonly>
                                    </td>
                                </tr>
                            </tbody>
                        </div>
                    </div>
                </div>
            </form>
            <app-pagination *ngIf="this.frtRateAccessorialsFormGroup.get('accessorials').value.length > 0" [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" (itemsPerPageChange)="itemsPerPageChanged($event)" [currentPage]="currentPage" (currentPageChange)="page($event)">
            </app-pagination>
        </div>
        <div class="usa-modal__footer" *ngIf="this.frtRateAccessorialsFormGroup.controls['accessorials'].value.length > 0">
            <ul class="usa-button-group">
                <li class="usa-button-group__item">
                    <button type="button" class="usa-button usa-button-outline" (click)="closeModal()">Close</button>
                </li>
                <li class="usa-button-group__item">
                    <button type="button" class="usa-button" [disabled]="(frtRateAccessorialsFormGroup.invalid)" (click)="saveAcc()">{{editButtonText}}</button>
                </li>
            </ul>
        </div>
    </div>
    <button class="usa-button usa-modal__close" aria-label="Close this window" (click)="closeModal()" data-close-modal>
    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
      <use xlink:href="/assets/uswds/img/sprite.svg#close"></use>
    </svg>
  </button>
</div>